import React from 'react';
import { WatchList, Watched, Container } from '../../components';

const WatchListPage = () => (
  <>
    <Container>
      <WatchList />
      <Watched />
    </Container>
  </>
);

export default WatchListPage;
